import { useConditionsEvaluator } from '../../utils/useConditionsEvaluator';

type ConditionEvaluatorProps = {
  conditions?: any;
  metadata?: Record<string, unknown>;
  children?: React.ReactElement;
};

function ConditionEvaluator({
  conditions,
  metadata = {},
  children,
}: ConditionEvaluatorProps) {
  const { isVisible } = useConditionsEvaluator(conditions, metadata);

  if (!isVisible) {
    return null;
  }

  return children ?? null;
}

type ConditionEvaluatorContainerProps = {
  conditions?: any;
  children?: React.ReactElement;
  conditionResult?: boolean;
  metadata?: Record<string, unknown>;
  name?: string;
};

export default function ConditionEvaluatorContainer({
  conditions,
  children,
  conditionResult,
  metadata = {},
}: Readonly<ConditionEvaluatorContainerProps>) {
  // conditionResult is an additional gate (e.g., AI hidden map) and should not
  // bypass regular condition evaluation.
  if (conditionResult === false) {
    return null;
  }

  return (
    <ConditionEvaluator conditions={conditions} metadata={metadata}>
      {children}
    </ConditionEvaluator>
  );
}
